import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import {
  PhoneForm,
  OTPForm,
  CITCForm,
  ProfileForm,
  VehicleForm,
  UpdateRequestForm
} from 'components/courier_signup'
import {
  CountDown,
  PresignedImageUpload
} from 'components'
import {
  IMaskDirective,
  ChoicesDirective,
  FlatpickrDirective
} from 'directives'
import modal from 'stores/modal'
import { unwrapProxy } from 'helpers/utils'

Alpine.plugin(persist)

const { params, errors } = window.FORM_DATA
const {
  nationality = '',
  carMake = 0,
  carModel = 0,
  carYear = null,
  sponsorName = null,
  nationalIdPicUploaded = false,
  carFrontPicUploaded = false,
  carBackPicUploaded = false
} = params

// TODO: move it to a separate file once the old store is gone
Alpine.store('form', {
  nationality,
  carMake,
  carModel,
  carYear,
  sponsorName,

  nationalIdPicUploaded,
  carFrontPicUploaded,
  carBackPicUploaded,

  errors,
  carModels: {},

  hasReadCarPictureGuide: Alpine.$persist(false).using(sessionStorage),
  hasReadPersonalPictureGuide: Alpine.$persist(false).using(sessionStorage),
  hasReadNationalIdGuide: Alpine.$persist(false).using(sessionStorage),

  init () {
    Alpine.effect(() => {
      this.loadCarModels(unwrapProxy(this.carMake))
    })
  },

  get saudiNationalIDMask () {
    if (unwrapProxy(this.nationality) === 'SAUDI') {
      return { mask: '1000000000' }
    } else {
      return { mask: '2000000000' }
    }
  },

  get carModelsByMake () {
    return this.carModels[unwrapProxy(this.carMake)]
  },

  async loadCarModels (carMake) {
    if (carMake && this.carModels[carMake] === undefined) {
      const response = await fetch(`${window.location.pathname}/car-models/${carMake}`)
      const data = await response.json()
      const ids = data.map(({ id }) => parseInt(id))

      if (!ids.includes(parseInt(this.carModel))) this.carModel = 0

      this.carModels[carMake] = data
    }
  }
})

Alpine.store('modal', modal)
Alpine.directive('imask', IMaskDirective)
Alpine.directive('choices', ChoicesDirective)
Alpine.directive('flatpickr', FlatpickrDirective)
Alpine.data('PresignedImageUpload', PresignedImageUpload)
Alpine.data('CountDown', CountDown)
Alpine.data('PhoneForm', PhoneForm)
Alpine.data('OTPForm', OTPForm)
Alpine.data('CITCForm', CITCForm)
Alpine.data('ProfileForm', ProfileForm)
Alpine.data('VehicleForm', VehicleForm)
Alpine.data('UpdateRequestForm', UpdateRequestForm)

window.Alpine = Alpine
Alpine.start()
